/* global axios */
import ApiClient from './ApiClient';

// v124: Privilégios por caixa (aba Privilégios em Settings > Caixas).
// Configurar = id 1 + Funções Restritas (guard no backend); `meus` = qualquer
// usuário logado (usado pelo filtro de tempo real das conversas).
class PrivilegiosAPI extends ApiClient {
  constructor() {
    super('privilegios', { accountScoped: true });
  }

  getInbox(inboxId) {
    return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/privilegios`);
  }

  saveInbox(inboxId, { userId, labels, atribuicao, participante }) {
    return axios.post(`${this.baseUrl()}/inboxes/${inboxId}/privilegios`, {
      user_id: userId,
      labels,
      atribuicao,
      participante,
    });
  }

  meus() {
    return axios.get(`${this.url}/meus`);
  }
}

export default new PrivilegiosAPI();
